import React, { Component } from "react";
import ReactDom from "react-dom";
import { Common } from "../../../utils";
class FileRead extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleFile = this.handleFile.bind(this);
  }
  handleFile(e) {
    var reader = new FileReader();
    var file = e.target.files[0];
    if (!file || !file.name.match(/.(jpg|jpeg|png|gif)$/i)) {
      Common.showErrorMessage("Not valid Image");
      return;
    }
    reader.onload = function(img) {
      ReactDom.findDOMNode(this.refs.in).value = "";
      this.props.handleFileChange(file, img.target.result);
    }.bind(this);
    reader.readAsDataURL(file);
  }

  render() {
    return (
      <input ref="in" type="file" accept="image/*" onChange={this.handleFile} />
    );
  }
}
export default FileRead;
